// extracted by mini-css-extract-plugin
export default {"root":"FooterLogos_root__nETfE","item":"FooterLogos_item__mqXB-","logo":"FooterLogos_logo__yBrgL"};